import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-manager-card',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  providers: [],
  templateUrl: './manager-card.component.html',
  styleUrl: './manager-card.component.scss',
})
export class ManagerCardComponent {
  @Input() manager!: Manager;
  @Output() deleteManager: EventEmitter<Manager> = new EventEmitter<Manager>();

  delete(): void {
    this.deleteManager.emit(this.manager);
  }

}